.back {
  position: fixed;
  top: calc(
    var(--tg-safe-area-inset-top, env(safe-area-inset-top, 0px)) +
      var(--tg-content-safe-area-inset-top, 0px) + 12px
  );
  left: 18px;
  z-index: 82;
}

.stateWrap {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 24px;
  text-align: center;
  color: var(--text-secondary);
}

.stateTitle {
  font-family: var(--client-font-heading, 'EB Garamond', Georgia, serif);
  font-size: 22px;
  color: var(--text-primary);
}

.spinner {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 3px solid rgba(var(--accent-rgb), 0.2);
  border-top-color: var(--accent);
  animation: focused-screen-spin 0.8s linear infinite;
}

@keyframes focused-screen-spin {
  to {
    transform: rotate(360deg);
  }
}

.stateBtn {
  padding: 12px 20px;
  border-radius: 14px;
  background: var(--accent-orb);
  color: var(--text-on-accent);
  font-weight: 700;
  box-shadow: var(--glow-amber);
}
